export const GET_TESTS_START = 'GET_TESTS_START'
export const GET_TESTS_SUCCEED = 'GET_TESTS_SUCCEED'

export const GET_CURRENT_TEST_START = 'GET_CURRENT_TEST_START'
export const GET_CURRENT_TEST_SUCCEED = 'GET_CURRENT_TEST_SUCCEED'
export const GET_CURRENT_TEST_FAIL = 'GET_CURRENT_TEST_FAIL'

export const GET_KEYWORDS_START = 'GET_KEYWORDS_START'
export const GET_KEYWORDS_SUCCEED = 'GET_KEYWORDS_SUCCEED'
